import request from "@/utils/requestJSON";

export function getCustomerServiceCommon() {
  return request({
    url: "/storage/CustomerService/CustomerServiceCommon.json",
    method: "get",
  });
}

export function getGoodService() {
  return request({
    url: "/storage/CustomerService/GoodService.json",
    method: "get",
  });
}

export function getClaimSettlement() {
  return request({
    url: "/storage/CustomerService/ClaimSettlement.json",
    method: "get",
  });
}

export function getPayService() {
  return request({
    url: "/storage/CustomerService/PayService.json",
    method: "get",
  });
}

export function getDamagePrevention() {
  return request({
    url: "/storage/CustomerService/DamagePrevention.json",
    method: "get",
  });
}

export function getEPolicyDownload() {
  return request({
    url: "/storage/CustomerService/EPolicyDownload.json",
    method: "get",
  });
}

export function getCerDownload() {
  return request({
    url: "/storage/CustomerService/CerDownload.json",
    method: "get",
  });
}

export function getFAQPage() {
  return request({
    url: "/storage/CustomerService/FAQPage.json",
    method: "get",
  });
}

export function getFileDownloadPage() {
  return request({
    url: "/storage/CustomerService/FileDownloadPage.json",
    method: "get",
  });
}

export function getFileDownload() {
  return request({
    url: "/storage/CustomerService/FileDownload.json",
    method: "get",
  });
}

export function getContactUsPage() {
  return request({
    url: "/storage/CustomerService/ContactUsPage.json",
    method: "get",
  });
}

export function getSignLanguagePage() {
  return request({
    url: "/storage/CustomerService/SignLanguagePage.json",
    method: "get",
  });
}

export function getMultiLanguagePage() {
  return request({
    url: "/storage/CustomerService/MultiLanguagePage.json",
    method: "get",
  });
}

export function getTermsFileCategory() {
  return request({
    url: "/storage/CustomerService/TermsFileCategory.json",
    method: "get",
  });
}

export function getTermsFile() {
  return request({
    url: "/storage/CustomerService/TermsFile.json",
    method: "get",
  });
}

export function getThanks() {
  return request({
    url: "/storage/CustomerService/Thanks.json",
    method: "get",
  });
}

export function getThanksList() {
  return request({
    url: "/storage/CustomerService/ThanksList.json",
    method: "get",
  });
}

export function getCompanyList() {
  return request({
    url: "/storage/CustomerService/CompanyList.json",
    method: "get",
  });
}
